'use strict';

module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};



//////////////////
// WEBPACK FOOTER
// ./~/_axios@0.20.0@axios/lib/cancel/isCancel.js
// module id = 130
// module chunks = 38